/**
 * Created by Ning Jiang on 2021-06-29.
 */

import {ContinueScreen} from "../../core/screen/ContinueScreen";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";
import {OktoberfestLayers, Layers} from "../view/OktoberfestLayers";
import {Oktoberfest} from "../Oktoberfest";
import {Translation} from "../../core/utils/Translation";
import {TextStyleOptions} from "@nolimitcity/slot-game/bin/text/TextStyleOptions";
import {DynamicTextsLine} from "../../core/utils/DynamicTextsLine";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {TimelineLite, TweenLite, Power3} from "gsap";
import {OktoberfestSound} from "../sound/OktoberfestSound";
import {OktoberfestParsedGameData} from "../server/data/OktoberfestParsedGameData";

export class FreespinOutro extends ContinueScreen {

    static FS_OUTRO_YOU_WON_TEXT_STYLE: TextStyleOptions = {
        fontFamily: "Open Sans",
        fontSize: "40px",
        fontWeight: "300",
        fill: "#ffffff"
    };
    static FS_OUTRO_TOTAL_WIN_TEXT_STYLE: TextStyleOptions = {
        fontFamily: "Open Sans",
        fontSize: "53px",
        fontWeight: "800",
        fill: "#ffffff"
    };
    private _textSpacing: number;
    private _textsLine: DynamicTextsLine;
    private _textYouWon: PIXI.Text;
    private _textTotalWin: PIXI.Text;
    private _textsLineYOffset: number = 25;
    private _backgroundContainer: PIXI.Container;
    private _blackOverlayContainer: PIXI.Container;
    private _fadeAnimation: TimelineLite;

    constructor() {
        super(OktoberfestLayers.getLayer(Layers.SCREENS)!);
        this.createFSAssets();
        this.showFsScreen(false);
    }

    public show(onContinueCallBack: () => void) {
        Oktoberfest.scatterMeter.onRemoveFromStage();
        Oktoberfest.fsMultiplier.onRemoveFromStage();
        this.showFsScreen(false);
        this.addBlackOverlay();
        this.showTexts();
        Oktoberfest.keypadPlugin.setZeroBetSpinCounter(-1);
        super.show(onContinueCallBack);
        this.enableContinueBtn(false);
    }

    public onOrientationChanged(): void {
        if (NolimitApplication.isLandscape) {
            this._continueButton.position.set(360 - this._continueButton.width * 0.5, 585);
        } else {
            const centerBottom = (NolimitApplication.screenBounds.bottom - 610) * 0.5 + 330;
            this._continueButton.position.set(360 - this._continueButton.width * 0.5, centerBottom);
        }
        if(this._blackOverlayContainer && this._blackOverlayContainer.children.length>0){
            let graphics = this._blackOverlayContainer.getChildAt(0) as PIXI.Graphics;
            graphics.clear();
            graphics.beginFill(0x000000, 1);
            graphics.drawRect(0, 0, NolimitApplication.screenBounds.width*1.5, NolimitApplication.screenBounds.height*1.5);
            graphics.endFill();
            graphics.endFill();
            this.adjustOverlay();
        }
    }

    private adjustOverlay(): void {
        if(NolimitApplication.isLandscape) {
            this._blackOverlayContainer.position.set(-450, 0);
            this._blackOverlayContainer.scale.set(2.0,2.0);

        }else{
            this._blackOverlayContainer.position.set(0, -550);
            this._blackOverlayContainer.scale.set(2.0,2.0);
        }
    }

    protected close(): TimelineLite {
        Oktoberfest.background.onFreespinOutroViewShow();
        Oktoberfest.reelDividers.onFreespinOutroViewShow();
        Oktoberfest.background.onFreespinOutroViewClosed();
        Oktoberfest.betlines.enableBetlineNumber(true);
        Oktoberfest.scatterMeter.onRemoveFromStage();
        Oktoberfest.fsMultiplier.onRemoveFromStage();
        Oktoberfest.leftIndicator.onReset();
        OktoberfestSound.switchMusic(
            {
                name : OktoberfestSound.MAIN_GAME_MUSIC,
                volume : 1
            },
            undefined,
            {name : OktoberfestSound.LOOP_NAME_BAR_AMBIENCE, to : 0, duration : 500}
        );
        Oktoberfest.foreground.resetLogoDefaultState();

        return super.close();
    }

    private createFSAssets(): void {
        const bg: PIXI.Sprite = new PIXI.Sprite(PIXI.Texture.WHITE);
        bg.anchor.set(0.5);
        bg.tint = 0x193364;
        bg.width = 1680;
        bg.height = 1680;
        bg.position.set(640,360);
        this._backgroundContainer = new PIXI.Container();
        let background: PIXI.Sprite = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("freespinOutroBackground")[0]);
        let fsOutroTextImage: PIXI.Sprite = new PIXI.Sprite(Oktoberfest.assetLoader.getTextures("fsOutroTextImage")[0]);
        this._backgroundContainer.addChild(bg, background);
        this._backgroundContainer.position.set(360, 360);
        fsOutroTextImage.position.set(360, 170);
        fsOutroTextImage.anchor.set(0.5, 0.5);
        this._backgroundContainer.pivot = new PIXI.Point(background.width * 0.5, background.height * 0.5);
        this._container.addChild(this._backgroundContainer);
        this._textSpacing = 10;
        this.initTexts();
        this.createFadeFadeToBlackAnimation();
        this._container.addChild(fsOutroTextImage);
        this._textsLine.position.set(360, 360);
    }

    private enableContinueBtn(bool: boolean): void {
        this._continueButton.visible = bool;
        this._continueButton.enable(bool);
    }

    private showFsScreen(toshow?: boolean) {
        this._textsLine.alpha = toshow ? 1 : 0;
        this._backgroundContainer.alpha = toshow ? 1 : 0;
        this._container.alpha = toshow ? 1 : 0;
    }

    private createFadeFadeToBlackAnimation(): void {
        this._blackOverlayContainer = new PIXI.Container();
        const blackOverlay: PIXI.Graphics = new PIXI.Graphics();
        blackOverlay.beginFill(0x000000, 1);
        blackOverlay.drawRect(0, 0, NolimitApplication.screenBounds.width*2.0, NolimitApplication.screenBounds.height*2.0);
        blackOverlay.endFill();
        blackOverlay.name="blackOverlay";
        this._blackOverlayContainer.addChild(blackOverlay);
        this._blackOverlayContainer.alpha = 0;
        this.adjustOverlay();

        this._fadeAnimation = new TimelineLite({
            paused: true, onComplete: () => {
                this.enableContinueBtn(true);
            }
        });
        this._fadeAnimation.add([
            new TweenLite(this._blackOverlayContainer, 2, {alpha: 0}),
            ()=>{
                OktoberfestSound.switchMusic(
                    {
                        name : OktoberfestSound.LOOP_NAME_BAR_AMBIENCE,
                        volume : 1
                    },
                    undefined,
                    {name : OktoberfestSound.FREESPIN, to : 0, duration : 500}
                );
                if(!this.getBelowStakeWinRestriction()) {
                    OktoberfestSound.soundPlayer.playTrack({name: OktoberfestSound.SOUND_NAME_FS_ENDS});
                }
            }
        ]);
        this._fadeAnimation.add([
            new TweenLite(this._blackOverlayContainer, 1.0, {alpha: 1})
        ]);
        this._fadeAnimation.add([
            () => this.makeVisible()
        ]);
        this._fadeAnimation.add([
            new TweenLite(this._blackOverlayContainer, 0.5, {alpha: 0, ease: Power3.easeOut})
        ]);
        this._fadeAnimation.add(() => this.removeBlackOverlay());
    }

    private makeVisible(): void {
        this.showFsScreen(true);
        this.addChild(this._blackOverlayContainer); //To make the black overlay stay on top of the transition screen.
    }

    private addBlackOverlay(): void {
        this.addChild(this._blackOverlayContainer);
        this._fadeAnimation.play(0);
    }

    private removeBlackOverlay(): void {
        this.removeChild(this._blackOverlayContainer);
    }

    private initTexts(): void {
        this._textsLine = new DynamicTextsLine();
        this._textsLine.textSpacing = this._textSpacing;
        this._textsLine.y += this._textsLineYOffset;
        this._container.addChild(this._textsLine);
        this._textYouWon = this._textsLine.createText(`${Translation.translation("You won:")}`, FreespinOutro.FS_OUTRO_YOU_WON_TEXT_STYLE);
        this._textTotalWin = this._textsLine.createText("0", FreespinOutro.FS_OUTRO_TOTAL_WIN_TEXT_STYLE);
    }

    private showTexts(): void {
        const win: number = Oktoberfest.model.parsedGameData.totalWin;
        this._textTotalWin.text = SlotGame.apiPlugin.currency.format(win);
        if(this.getBelowStakeWinRestriction()){
            this._textYouWon.text="";
        }else{
            this._textYouWon.text=`${Translation.translation("You won:")}`, FreespinOutro.FS_OUTRO_YOU_WON_TEXT_STYLE;
        }
        this._textsLine.arrange();
    }
    private getBelowStakeWinRestriction(): boolean {
        if (!Oktoberfest.apiPlugin.gameClientConfiguration.belowStakeWinRestriction) {
            return false;
        }
        const data: OktoberfestParsedGameData = Oktoberfest.model.parsedGameData;
        let playedBetValue: number = data.playedBetValue;
        return ( data.totalWin / playedBetValue ) <= 1;
    }
}